
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/use-case/kryptogo-wallet",
      function () {
        return require("private-next-pages/use-case/kryptogo-wallet.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/use-case/kryptogo-wallet"])
      });
    }
  